import { useCore } from '@/composables/core/index.js'

import { useLogger } from '@booksy-com/vue-tools'

import { ROUTE_META_PARAMS } from '../consts.js'
const logger = useLogger('router.guard.check-access-level')

export default function (route, from, next) {
  logger.debug(route.path)

  // business route
  const br = !!route.matched.find(r => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!br) {
    return next()
  }

  const levels = route.matched
    .filter(r => r.meta[ROUTE_META_PARAMS.ACCESS_LEVEL])
    .map(r => r.meta[ROUTE_META_PARAMS.ACCESS_LEVEL])

  // shortcut: allowed for everyone
  if (!levels.length) {
    return next()
  }

  const { store } = useCore()
  const user = store.state.identity.user

  // shortcut: user can access
  if (user && levels.every(level => { return user.access_levels[level] })) {
    return next()
  }

  logger.debug('redirecting to "forbidden" view...')
  next({
    name: 'forbidden',
    params: { businessId: route.params.businessId },
    query: { reason: 'no-access' }, // xxx
  })
}
